<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <div class="company_courses">
      <div>
        <card class="no-border-card employee-content-wrap" footer-classes="pt-1">
          <template slot="header">
            <div class="row align-items-center">
              <div class="col-md-4 text-left">
                <h2 class="mb-0">Courses</h2>
              </div>
              <div class="col-md-8 text-right">
                <!-- Action buttons if needed -->
              </div>
            </div>
          </template>

          <div>
            <div class="row d-flex justify-content-center justify-content-sm-start flex-wrap mb-2">
              <div class="col-md-3 search-style mb-2">
                <label>Search:</label>
                <base-input
                  v-model="searchQuery"
                  v-on:keyup="debouncedSearch"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                />
              </div>

              <div class="col-md-3 form-group select-style mb-2">
                <label>Showing:</label>
                <el-select
                  v-model="perPage"
                  class="select-primary pagination-select"
                  @change="changeItemsPerPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in itemsPerPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </div>

              <div class="col-md-3 form-group select-style mb-2" v-if="editor != 'manager'">
                <label>Status:</label>
                <el-select
                  v-model="filters.courseStatus"
                  @change="resetToFirstPage"
                  placeholder="Filter by Course Status"
                >
                  <el-option
                    class="select-default"
                    v-for="item in status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
            </div>

            <div class="user-eltable table-style-fancy border overflow-hidden">
              <el-table
                :data="tableData"
                row-key="id"
                role="table"
                class="coursesGrid"
                header-row-class-name="thead-light custom-thead-light"
              >
                <el-table-column
                  align="left"
                  min-width="400px"
                  label="Course Name"
                  prop="course_name"
                  class-name="left-align ignore-translation"
                  sortable
                >
                  <template slot-scope="props">
                    <router-link
                      :to="`/company_course_details?id=${props.row.id}&certificate_id=${props.row.certificate_id}`"
                    >
                      <span v-if="secondaryCourseCheack && props.row.secondary_course_name">
                        {{ props.row.secondary_course_name }}
                      </span>
                      <span v-else>{{ props.row.course_name }}</span>
                    </router-link>
                  </template>
                </el-table-column>

                <el-table-column
                  align="left"
                  min-width="200px"
                  label="Course Length (mins)"
                  class-name="center-align"
                >
                  <template slot-scope="props">
                    <span>{{ props.row.course_length }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  align="left"
                  min-width="200px"
                  label="Assigned Employees"
                >
                  <template slot-scope="props">
                    {{ props.row.assigned_employees }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div slot="footer" class="d-flex justify-content-end">
            <nav v-if="totalData > 0">
              <div class="row">
                <div class="col-md-12">
                  <ul class="pagination custompagination justify-content-end align-items-center">
                    <p class="p-0 m-0 mr-2">
                      Showing {{ ((currentPage - 1) * perPage) + 1 }} to
                      {{ Math.min(currentPage * perPage, totalData) }} of
                      {{ totalData }} entries
                    </p>

                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
                        <i class="fa fa-caret-left"></i>
                      </a>
                    </li>

                    <li v-for="page in visiblePageNumbers"
                        :key="page"
                        class="page-item"
                        :class="{ active: page === currentPage }">
                      <a class="page-link" href="#" @click.prevent="changePage(page)">
                        {{ page }}
                      </a>
                    </li>

                    <li class="page-item" :class="{ disabled: currentPage === lastPage }">
                      <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
                        <i class="fa fa-caret-right"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import Swal from "sweetalert2";

let searchTimeout = null;

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },

  data() {
    return {
      loading: false,
      hot_user: "",
      hot_token: "",
      company_id: "",
      companyName: "",

      // Pagination
      currentPage: 1,
      perPage: 50,
      totalData: 0,
      lastPage: 1,
      itemsPerPageOptions: [25, 50, 75, 100],

      // Filters
      searchQuery: "",
      filters: {
        courseStatus: "Active"
      },

      status: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
        { label: "Show All", value: "" }
      ],

      // Data
      tableData: [],
      selectedRows: [],

      // User info
      locationManager: false,
      location_id: "",
      admin_id: "",
      editor: "",
      secondaryCourseCheack: 0
    };
  },

  computed: {
    visiblePageNumbers() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.lastPage, start + maxVisible - 1);

      // Adjust start if we're near the end
      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },

    debouncedSearch() {
      return () => {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
          this.resetToFirstPage();
        }, 300);
      };
    }
  },

  watch: {
    'filters.courseStatus'() {
      this.resetToFirstPage();
    }
  },

  created() {
    this.initializeUserData();
    this.fetchData();
  },

  methods: {
    initializeUserData() {
      if (localStorage.getItem("hot-token")) {
        this.hot_user = localStorage.getItem("hot-user");
        this.hot_token = localStorage.getItem("hot-token");
        this.company_id = localStorage.getItem("hot-user-id");
        this.companyName = localStorage.getItem("hot-company-name");
        this.admin_id = localStorage.getItem("hot-admin-id");
      }

      if (localStorage.getItem("hot-sidebar") === "location_manager") {
        this.locationManager = true;
        this.location_id = localStorage.getItem("hot-location-id");
      }

      if (localStorage.getItem("hot-user") === "manager") {
        this.editor = "manager";
      }
    },

    fetchData() {
      this.loading = true;

      this.$http.post("company/courses-optimized", {
        search: this.searchQuery,
        company_course_status: this.filters.courseStatus,
        company_id: this.company_id,
        page: this.currentPage,
        per_page: this.perPage
      })
      .then(resp => {
        const data = resp.data;

        // Update pagination info
        this.totalData = data.total;
        this.currentPage = data.current_page;
        this.lastPage = data.last_page;

        // Update company info
        this.companyName = data.company_name.company_name || data.company_name;
        this.secondaryCourseCheack = data.company_name.secondary_course_status || 0;

        // Process course data
        this.tableData = this.processCourseData(data.courses);
      })
      .catch(error => {
        console.error('Error fetching courses:', error);
        this.$message.error('Failed to load courses');
      })
      .finally(() => {
        this.loading = false;
      });
    },

    processCourseData(courses) {
      return courses.map(course => ({
        id: course.course_id,
        course_name: course.info?.name || '',
        secondary_course_name: course.info?.secondary_course_name || '',
        course_length: course.info?.length || 0,
        assigned_location: course.location_count || 0,
        assigned_employees: course.employee_count || 0,
        courseEmployeeData: course.course_employee || [],
        certificate_id: course.certificate?.certificate_id || '',
        company_course_status: course.company_course_status === 1
      }));
    },

    changePage(page) {
      if (page >= 1 && page <= this.lastPage && page !== this.currentPage) {
        this.currentPage = page;
        this.fetchData();
      }
    },

    changeItemsPerPage(value) {
      this.perPage = value;
      this.resetToFirstPage();
    },

    resetToFirstPage() {
      this.currentPage = 1;
      this.fetchData();
    },

    changeStatus(index, row) {
      const prevVal = row.company_course_status;
      const status = prevVal ? 0 : 1;

      Swal.fire({
        title: "Are you sure?",
        text: "You want to change status!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
      .then(result => {
        if (result.value) {
          this.$http.post("/company/change_course_status", {
            status: status,
            course_id: row.id,
            company_id: this.company_id
          })
          .then(() => {
            this.fetchData(); // Refresh current page
            Swal.fire({
              title: "Success!",
              text: "Status has been changed.",
              icon: "success",
              confirmButtonClass: "btn btn-success"
            });
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "Failed to change status!",
              icon: "error",
              confirmButtonClass: "btn btn-success"
            });
          });
        }
      });
    },

    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    }
  }
};
</script>

<style scoped>
.no-border-card .card-footer {
  border-top: 0;
}

@media only screen and (max-width: 1024px),
  (min-device-width: 768px) and (max-device-width: 1024px) {
  .coursesGrid >>> table.el-table__body td:nth-of-type(1):before {
    content: "Course Name";
  }
  .coursesGrid >>> table.el-table__body td:nth-of-type(2):before {
    content: "Course Length";
  }
  .coursesGrid >>> table.el-table__body td:nth-of-type(3):before {
    content: "Assigned Employees";
  }
  .coursesGrid >>> table.el-table__body td:nth-of-type(4):before {
    content: "Status";
  }
}
</style>
